<template>
    <ContentOrLoading>
        <ModalComponent
            name="crear-etiqueta"
            title="Crear nueva etiqueta"
            @close="close"
        >
            <FormComponent :etiqueta="tempTag" @terminado="crear()"/>
        </ModalComponent>
    </ContentOrLoading>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormComponent from "../FormComponent";

    export default {
        props: ['etiqueta'],
        data() {
            return {
                tempTag: Object.assign({}, this.etiqueta)
            }
        },
        methods: {
            close() {
                this.$emit('close', 'crear-etiqueta');
            },
            crear() {
                this.$emit('crear', this.tempTag);
            }
        },
        watch: {
            etiqueta(newVal) {
                this.tempTag = Object.assign({}, newVal);
            }
        },
        components: {
            ModalComponent, FormComponent
        }
    }
</script>
